// ======================================================================
// File Name       : ServiceLogin
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { SERVICE_SEARCH, SERVICE_LOGIN } from '../constants/ActionTypes';

const initialState = {
  serviceInfo: {
    recordNum: 0,
    serviceList: [],
  },
  serviceLoginInfo: {
    institutionId: '',
    serviceName: '',
    serviceType: null,
    managementFunctionAuthorityInfo: {},
  },
};

export default function serviceLogin(state = initialState, action) {
  switch (action.type) {
    case SERVICE_SEARCH: {
      const { serviceInfo } = action;
      return { ...state, serviceInfo };
    }
    case SERVICE_LOGIN: {
      const { serviceLoginInfo } = action;
      return { ...state, serviceLoginInfo };
    }
    default:
      return state;
  }
}
